import { useQuery } from "@apollo/client";

import { GqlProjectUserGetAllUsersParams } from "~/__generated__";

import { ProjectUserGetAllWithAccessToProjectDocument } from "../queries.generated";

export default function useProjectUserGetAllWithAccessToProject(params: GqlProjectUserGetAllUsersParams) {
    const { data, loading, error } = useQuery(ProjectUserGetAllWithAccessToProjectDocument, {
        variables: {
            params,
        },
        errorPolicy: "all",
    });

    const queryInfo = data?.projectUserGetAllWithAccessToProject.queryInfo;

    return {
        loading,
        error,
        totalRows: queryInfo?.paginationOption.total || 0,
        sortableColumns: queryInfo?.sortableColumns,
        data: data?.projectUserGetAllWithAccessToProject?.data,
    };
}
